/*
<summary>
    This functional common component provides modal popup that shows print confirmation message (i.e. are you sure
    want to print again).
    Developer: Copilot, Created Date:11-May-2026
</summary>
<returns>Returns JSX</returns>
*/
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import LoaderButton from '../../button/loader-button';
import printConfirm from '../../../assets/Images/printConfirm.png';

interface Props {
  modalSubmit: () => void;
  modalClosed: () => void;
  isLoading: boolean;
  title: string;
  message?: string;
  className?: string;
  note?: string;
}

const ConfirmPrintPopup: React.FC<Props> = (props) => {
  return (
    <Modal
      show={true}
      centered
      dialogClassName="logout-popup"
      onHide={() => {}}
    >
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={props.title} />
          <button
            onClick={props.modalClosed}
            disabled={props.isLoading}
            className="Crossicons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div className="bootbox-body">
          <FormattedMessage id={props.message} />
        </div> */}
        <div className="bootbox-body p-3 pb-0">
            <div className="logout_modal_icon">
            <img
              src={printConfirm}
              alt="Centra-SD"
              className="img-fluid w-25 meritech-logo"
            />
          </div>
          <h3 className="my-3 pt-2">
            <FormattedMessage id={props.message}  />
          </h3>
        </div>
        <div className="d-flex justify-content-center align-items-center gap-3">
                  <div className="">
                    <LoaderButton
          type="submit"
                      variant="primary"
                      onClick={props.modalSubmit}
          isLoading={props.isLoading}
                      text="button_confirm"
                      className="btnOkSize my-2"
                    />
                  </div>
                  <div className="">
                    <Button
                      variant="light-danger border-0"
                      onClick={props.modalClosed}
          disabled={props.isLoading}
                      className="btnOkSize"
                    >
                      <FormattedMessage id="cancel" />
                    </Button>
                  </div>
                </div>
      </Modal.Body>

    </Modal>
  );
};

export default ConfirmPrintPopup;